import { render, staticRenderFns } from "./vendor-add.vue?vue&type=template&id=2b83d6c1&scoped=true&"
import script from "./vendor-add.vue?vue&type=script&lang=js&"
export * from "./vendor-add.vue?vue&type=script&lang=js&"
import style0 from "./vendor-add.vue?vue&type=style&index=0&id=2b83d6c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b83d6c1",
  null
  
)

export default component.exports